import {addLocaleData} from 'react-intl'; // PiCoBlock — en + fr

import {localeData, isRtl} from 'openblock-l10n';
import editorMessages from 'openblock-l10n/locales/editor-msgs';

addLocaleData(localeData);

// Override upstream "OpenBlock" branding with "PiCoBlock" for all locales.
const brandPatch = {
    'gui.alerts.lostPeripheralConnection': 'PiCoBlock lost connection to {extensionName}.',
    'gui.connection.unavailable.installscratchlink': 'Make sure you have PiCoBlock Link installed and running',
    'gui.crashMessage.description': 'We are so sorry, but it looks like PiCoBlock has crashed. This bug has been automatically reported to the PiCoBlock Team. Please refresh your page to try again.',
    'gui.telemetryOptIn.label': 'Report statistics to improve PiCoBlock',
    'gui.telemetryOptIn.body1': 'The PiCoBlock Team is always looking to better understand how PiCoBlock is used around the world. To help support this effort, you can allow PiCoBlock to automatically send usage information to the PiCoBlock Team.',
    'gui.telemetryOptIn.optInText': 'Share my usage data with the PiCoBlock Team',
    'gui.telemetryOptIn.optOutText': 'Do not share my usage data with the PiCoBlock Team',
    'gui.updateModel.alreadyLatestTips': 'PiCoBlock is already the latest version.',
    'gui.unsupportedBrowser.notRecommended': 'We are very sorry, but it looks like you are using a browser version that PiCoBlock does not support. We recommend updating to the latest version of a supported browser such as Google Chrome, Mozilla Firefox, Microsoft Edge, or Apple Safari.',
    'gui.unsupportedBrowser.description': 'We are very sorry, but PiCoBlock does not support this browser. We recommend updating to the latest version of a supported browser such as Google Chrome, Mozilla Firefox, Microsoft Edge, or Apple Safari.',
    'gui.webglModal.description': 'Unfortunately it looks like your browser or computer {webGlLink}. This technology is needed for PiCoBlock to run.'
};

const patchedMessages = {};
Object.keys(editorMessages).forEach(locale => {
    patchedMessages[locale] = Object.assign({}, editorMessages[locale], brandPatch);
});

const UPDATE_LOCALES = 'scratch-gui/locales/UPDATE_LOCALES';
const SELECT_LOCALE = 'scratch-gui/locales/SELECT_LOCALE';

const initialState = {
    isRtl: false,
    locale: 'en',
    messagesByLocale: patchedMessages,
    messages: patchedMessages.en
};

const reducer = function (state, action) {
    if (typeof state === 'undefined') state = initialState;
    switch (action.type) {
    case SELECT_LOCALE:
        return Object.assign({}, state, {
            isRtl: isRtl(action.locale),
            locale: action.locale,
            messagesByLocale: state.messagesByLocale,
            messages: state.messagesByLocale[action.locale]
        });
    case UPDATE_LOCALES: {
        const patched = {};
        Object.keys(action.messagesByLocale).forEach(locale => {
            patched[locale] = Object.assign({}, action.messagesByLocale[locale], brandPatch);
        });
        return Object.assign({}, state, {
            isRtl: state.isRtl,
            locale: state.locale,
            messagesByLocale: patched,
            messages: patched[state.locale]
        });
    }
    default:
        return state;
    }
};

const selectLocale = function (locale) {
    return {
        type: SELECT_LOCALE,
        locale: locale
    };
};

const setLocales = function (localesMessages) {
    return {
        type: UPDATE_LOCALES,
        messagesByLocale: localesMessages
    };
};
const initLocale = function (currentState, locale) {
    if (currentState.messagesByLocale.hasOwnProperty(locale)) {
        return Object.assign(
            {},
            currentState,
            {
                isRtl: isRtl(locale),
                locale: locale,
                messagesByLocale: currentState.messagesByLocale,
                messages: currentState.messagesByLocale[locale]
            }
        );
    }
    // don't change locale if it's not in the current messages
    return currentState;
};
export {
    reducer as default,
    initialState as localesInitialState,
    initLocale,
    selectLocale,
    setLocales
};
